module.exports = __webpack_public_path__ + "static/media/mira_logo_sketch_1.1f3e4902.gif";